const SituacaoPagamento = {
  INICIAL: 'inicial',
  ATIVO: 'ativo',
  CHECKOUT_CONCLUIDO: 'checkout-concluido',
  CANCELAMENTO_SOLICITADO: 'cancelamento-solicitado',
  CANCELADO: 'cancelado'
};

export default SituacaoPagamento;
